<template>
<div>

  <div class="card">
    <header class="card-header">
      <p class="card-header-title">
        <b-icon icon="server" /> Instances
      </p>
      <span class="card-header-icon" aria-label="more options">
        <b-button type="is-link is-small" :loading="loading" icon-left="sync" @click="refresh">Refresh</b-button>
      </span>
    </header>

    <div class="card-content" v-if="unauthorized">
      <div class="content">
        <p class="has-text-centered has-text-weight-bold is-size-4">
          <b-icon icon="exclamation-triangle" /> <br/>
          Unauthorized!
        </p>
      </div>
    </div>

    <div class="card-content" v-else>
      <div class="content">
        <nav class="level">
          <div class="level-left">
            <div class="level-item">
              <p class="subtitle is-5">
                <strong>{{ data.length }}</strong> Instances
              </p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <b-switch v-model="instancesSearchable"><b-icon icon="search"/></b-switch>
            </div>
          </div>
        </nav>
        <b-table
          class="instances-table"
          :data="data"
          hoverable
          paginated
          per-page="20"
          pagination-simple

          default-sort="created_at">
        <b-table-column field="name" label="Name" sortable :searchable="instancesSearchable" v-slot="props">
          {{ props.row.name }}
        </b-table-column>
        <b-table-column field="created_at" label="CreatedAt" sortable width="160" v-slot="props">
          {{ props.row.created_at }}
        </b-table-column>
        <b-table-column field="user" label="User" sortable :searchable="instancesSearchable" v-slot="props">
          {{ props.row.user }}
        </b-table-column>
        <b-table-column field="challenge" label="Challenge" sortable :searchable="instancesSearchable" v-slot="props">
          {{ props.row.challenge }}
        </b-table-column>
        <b-table-column field="ttlSeconds" label="TTL" sortable width="70" v-slot="props">
          {{ props.row.ttlSeconds }}
        </b-table-column>
        <b-table-column field="identifier" label="Identifier" sortable :searchable="instancesSearchable" width="110" v-slot="props">
          {{ props.row.identifier }}
        </b-table-column>
        <b-table-column field="connectionInfo" label="Connection Info" :searchable="instancesSearchable" width="250" v-slot="props">
          {{ props.row.connectionInfo }}
        </b-table-column>
        <b-table-column field="flag" label="Flag" :searchable="instancesSearchable" width="250" v-slot="props">
          {{ props.row.flag }}
        </b-table-column>
        <b-table-column label="Actions" width="80" centered v-slot="props">
          <a v-on:click="deleteInstance(props.row)">
            <b-icon icon="trash" />
          </a>
        </b-table-column>
        </b-table>
      </div>
    </div>
  </div>

  <div class="card mt-5">
    <header class="card-header">
      <p class="card-header-title">
        <b-icon icon="list-alt" /> Instancer Log
      </p>
      <span class="card-header-icon" aria-label="more options">
        <b-button type="is-link is-small" :loading="logLoading" icon-left="sync" @click="refreshLogs">Refresh</b-button>
      </span>
    </header>

    <div class="card-content" v-if="unauthorized">
      <div class="content">
        <p class="has-text-centered has-text-weight-bold is-size-4">
          <b-icon icon="exclamation-triangle" /> <br/>
          Unauthorized!
        </p>
      </div>
    </div>

    <div class="card-content" v-else>
      <div class="content">
        <nav class="level">
          <div class="level-left">
            <div class="level-item">
              <p class="subtitle is-5">
                <strong>{{ logData.length }}</strong> Entries
              </p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <b-switch v-model="logSearchable"><b-icon icon="search"/></b-switch>
            </div>
          </div>
        </nav>
        <b-table
          class="instancer-log-table"
          :data="logData"
          hoverable
          paginated
          per-page="20"
          pagination-simple
          scrollable
          default-sort="timestamp"
          default-sort-direction="desc">
        <b-table-column field="timestamp" label="Timestamp" sortable width="300" v-slot="props">
          {{ props.row.timestamp }}
        </b-table-column>
        <b-table-column field="action" label="Action" sortable :searchable="logSearchable" width="110" v-slot="props">
          {{ props.row.action }}
        </b-table-column>
        <b-table-column field="user" label="User" sortable :searchable="logSearchable" v-slot="props">
          {{ props.row.user }}
        </b-table-column>
        <b-table-column field="challenge" label="Challenge" sortable :searchable="logSearchable" v-slot="props">
          {{ props.row.challenge }}
        </b-table-column>
        <b-table-column field="instance_name" label="Instance" sortable :searchable="logSearchable" width="200" v-slot="props">
          {{ props.row.instance_name }}
        </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      unauthorized: false,
      data: [],
      loading: false,
      instancesSearchable: false,
      logData: [],
      logLoading: false,
      logSearchable: false,
    };
  },
  methods: {
    async refresh() {
      try {
        this.loading = true;
        this.data = await this.$ctforge.api.get('/instancer/admin/list');
      } catch (e) {
        if (e.status_code === 401) {
          this.unauthorized = true;
        } else {
          this.notify(e, 'is-error');
        }
      } finally {
        this.loading = false;
      }
    },
    async refreshLogs() {
      try {
        this.logLoading = true;
        this.logData = await this.$ctforge.api.get('/instancer/admin/log');
      } catch (e) {
        if (e.status_code === 401) {
          this.unauthorized = true;
        } else {
          this.notify(e, 'is-error');
        }
      } finally {
        this.logLoading = false;
      }
    },
    deleteInstance(row) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Instance',
        message: `Are you sure you want to <b>delete</b> instance ${row.name}? This action cannot be undone.`,
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            const challenge = encodeURIComponent(row.challenge);
            const instanceName = encodeURIComponent(row.name);
            await this.$ctforge.api.post(`/instancer/${challenge}/destroy?instance_name=${instanceName}`);
            await this.refresh();
            await this.refreshLogs();
            this.notify('Instance Deleted', 'is-info');
          } catch (e) {
            this.notify(e.message || e, 'is-danger');
          }
        },
      });
    },
  },
  async mounted() {
    await this.refresh();
    await this.refreshLogs();
  },
};
</script>
<style>
.instances-table table,
.instancer-log-table table {
  table-layout: fixed;
  width: 100%;
}

.instances-table td,
.instances-table th,
.instancer-log-table td,
.instancer-log-table th {
  white-space: normal;
  word-break: break-word;
  vertical-align: middle !important;
}

.instances-table td,
.instances-table th {
  font-size: 0.8rem;
}

.instancer-log-table td,
.instancer-log-table th {
  font-size: 0.85rem;
}
</style>
